import { getDocId } from '@js/utils-feeds';
import { query, getQuery } from '@js/utils';
import wv from '@cpc/lib-browser-jsapi';

const docInfo = window.pageData?.DOCINFO || {};
export const cmtadcf = query.get('__cmtadcf__') || 3;

export const pageHost =
  window.location.origin || 'https://news.heytapdownload.com';

/**
 * 是否屏蔽详情页 文章内容底下的广告
 * @returns
 */
export function isShieldFirstAd() {
  return (
    window.wv?.isMethodValid('BrowserIFlow.getConfigValue') &&
    !!+wv.getConfigValue('CommonConfig_detailPage_shieldFirstAd').data
  );
}

export const COMMENT_BLOCKING_TIP = '系统维护中，评论暂不开放';
export const browserPartner = query.get('browser_partner') || 'browser';
export const iflowScene = query.get('iflowScene') || undefined;
export const buuid = query.get('__buuid__') || undefined;
export const channel = query.get('__channel__') || undefined; // 用于判断是不是push详情页
export const enterId = window.BrowserWeb?.getEnterId?.() || ''; // 用户通过什么方式启动浏览器app https://odocs.myoas.com/sheets/2wAlXOQO70FBKDAP/MODOC/ 《浏览器app启动方式汇总》
export const isPush = enterId === 'push' || channel === 'push' || ''; // 用于判断是不是push详情页
export const _docId = query.get('__docId__') || getDocId;
export const stat_id = query.get('rid') || undefined;
export const isTop = query.get('isTop') || false; // 是否为置顶文章

export const fromSmallRedBook = query.get('__redBookStyle__') && +query.get('__redBookStyle__') > 0; // 是否来源为小红书
export const isSmallRedBook =
  fromSmallRedBook && docInfo?.contentType !== 2 && docInfo?.contentType !== 4; // 是否展示小红书页面样式(排除短视频,小视频)

export const isNewPush = isPushInfinity() || false; // 是否为新版push详情页 展示无限流
export const pushId = query.get('__pushid_byclient__') || ''; // pushId
export const fromId = getQuery('__fromId__') || void 0;
export const styleType = query.get('__styleType__') || void 0;
export const showReSearch = query.get('ReSearch') || 1; // 相关搜索开关
export const showRecommended = query.get('__recommended__') || 1; // 相关新闻开关

// 详情页内 列表无限流
export function isListInfinity() {
  if (process.env.NODE_ENV === 'development') {
    return false;
  }

  if (isSmallRedBook) {
    return false;
  }

  if (window.BrowserNormal?.getAppHost?.() === 3) {
    return true;
  }

  const result = query.get('CommonConfig_infinity_detailPage');
  if (result) {
    return !!+result;
  }
  if (isPush || !window.wv?.isMethodValid('BrowserIFlow.getConfigValue')) {
    return false;
  }

  return (
    !!+wv.getConfigValue('CommonConfig_infinity_detailPage').data &&
    browserPartner !== 'weather'
  );
}

// 详情页内 push无限流
export function isPushInfinity() {
  if (process.env.NODE_ENV === 'development') {
    return false;
  }

  if (isSmallRedBook) {
    return false;
  }

  const result = query.get('CommonConfig_infinity_pushDetailPage');
  if (result) {
    return !!+result;
  }
  if (!window.wv?.isMethodValid('BrowserIFlow.getConfigValue')) {
    return false;
  }
  return (
    isPush && !!+wv.getConfigValue('CommonConfig_infinity_pushDetailPage').data
  );
}

// 详情页内 短小混
export function isMixedVideo() {
  if (window.BrowserNormal?.getAppHost?.() === 3) {
    return false;
  }
  if (!window.wv?.isMethodValid('BrowserIFlow.isIFlowMixedVideo')) {
    return false;
  }
  return !!wv.invoke('BrowserIFlow.isIFlowMixedVideo').data;
}

// 详情页内 是否开启无限流
export function isInfinity() {
  return isListInfinity() || isPushInfinity();
}

// 详情页内 是否开启相关搜索
export function useRelatedSearch() {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (!window.wv?.isMethodValid('BrowserIFlow.getConfigValue')) {
    return true;
  }
  const result = wv.getConfigValue('CommonConfig_relatedSearch').data;
  return typeof result !== 'undefined' ? !!+result : true;
}

/**
 * 详情页类型 detailPage(有限流) infinity(无限流)  短小混(mixed)
 */
export function getDetailPageMode() {
  if (isMixedVideo()) {
    return 'mixed';
  }
  if (window.modulesConfig?.relatedNewsFlow?.isShow) {
    return 'infinity';
  }
  return 'detailPage';
}


// 内容中台映射关系
export const contentTypeMap = {
  1: '', // 图文
  2: 'video', // 短视频
  3: 'gallery', // 图集
  4: 'video', // 小视频
  5: '', // 未知类型,
  6: '', //图片
  0: '', // 文字,
  11: '', // 短视频和小视频
  36: '', // 音乐专辑
  37: '', // 音乐歌曲
  38: '', // 音乐歌单
  39: '', // 音乐排行榜,
  40: '', // 小说类型
  '-1': '', // ''
  '-2': '', //所有类别
};
